module.exports = __webpack_public_path__ + "media/contractor-reporting/real-time-visibility-07dc6e1a.png";